<template>
    <div
        class="location-filter"
        :class="{ 'location-filter--defaulted': (location || {}).id === (defaultLocation || {}).id }"
    >
        <span class="icon-location-marker"></span>
        <span class="location-filter__near">{{ locationFilterCopy }}</span>
        <CoreLocation
            data-e2e-component="core-location"
            :current-location="defaultLocation"
            :current-location-label="$config.defaultLocation
                ? `${$config.defaultLocation.city}, ${$config.defaultLocation.subdivision_code}`
                : 'Current Location'"
            :placeholder="'Select Location'"
            :selected-location="location"
            @error="$emit('error')"
            @select="$emit('select', $event)"
        >
            <template slot="location" slot-scope="{ location }">
                <span v-if="location.subdivision_code">{{ location.city }}, {{ location.subdivision_code }}</span>
                <span v-else>{{ location.city }}</span>
            </template>
            <span class="icon-chevron-lg-down" slot="caret"></span>
        </CoreLocation>
    </div>
</template>

<script>
import CoreLocation from 'core/components/LocationComponent.vue'

export default {
    name: 'LocationFilter',
    components: {
        CoreLocation
    },
    props: {
        defaultLocation: {
            default () { return null },
            required: false,
            validate (val) { return val === null || typeof val === 'object' }
        },
        location: {
            default () { return null },
            required: false,
            validate (val) { return val === null || typeof val === 'object' }
        },
        locationFilterCopy: {
            type: String,
            required: false,
            default: 'Events Near'
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.location-filter {
    padding-left: 20px;
    position: relative;
    z-index: 30;

    &.location-filter--defaulted {
        & >>> .cancel-selection {
            display: none;
        }

        & >>> .open-menu-icon {
            display: inline-block !important;
        }
    }

    & .fx-location-component {
        & >>> .selection,
        & >>> .selection-placeholder,
        & >>> .selection-value {
            color: #808689;
            font-size: var(--fs-large);
            font-weight: var(--fw-light);
            text-decoration: underline;
        }
        & >>> .cancel-selection {
            color: #808689;
            font-size: var(--fs-large);
            font-weight: var(--fw-light);
            text-decoration: none;
        }
    }

    & .icon-chevron-lg-down {
        color: #808689;
        font-size: 14px;
        position: absolute;
        right: 0;
        top: 1px;
    }

    & .icon-location-marker {
        color: #808689;
        font-size: var(--fs-large);
        left: 0;
        position: absolute;
        top: 1px;
    }

    & .location-filter__near {
        display: none;
    }

    & >>> li {
        padding: 10px 16px;

        &.highlighted,
        &:active,
        &:focus,
        &:hover {
            padding-left: 12px;
        }
    }

    & >>> .location-menu {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        width: auto;
        z-index: 20;
    }

    & >>> .open-menu-icon {
        display: inline-block;
        height: 16px;
        position: relative;
        width: 16px;
    }

    @media (--mq-medium-min) {
        & .fx-location-component {
            & >>> .selection,
            & >>> .selection-placeholder,
            & >>> .selection-value {
                font-size: var(--fs-large);
            }
        }
    }

    @media (--mq-large-min) {
        & .location-filter__near {
            color: #808689;
            display: inline;
            font-size: var(--fs-large);
            font-weight: 300;
            margin-right: 4px;
        }
    }
}
</style>
